import { isValidNumber, parse } from 'libphonenumber-js';
import { isNil } from 'lodash';

import FLAG from 'config/flag.singleton';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToSpacelessString from 'utils/converters/fromAnyToSpacelessString.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';

const L = logger('validatePhone');

const USE_SPAM_LOG = fromAnyToBool(FLAG.loggerSpam);

const DEFAULT_COUNTRY_CODE = 'GB';
const RE_UK_PHONE =
  // eslint-disable-next-line max-len,no-useless-escape
  /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/;
const RE_ANY_PHONE = /^[0-9+)(\s]*$/;

const validateUsingLib = withOptions(({ value, countryCode }) => {
  try {
    // NOTE: numbers starting with 0204...0205, 0206 and 0209 are valid UK numbers, but not for libphonenumber-js

    // NOTE: need to know country code since user will not type it in
    const cc = fromAnyToTrimmed(countryCode) || DEFAULT_COUNTRY_CODE;
    const parsed = parse(value, cc);

    if (USE_SPAM_LOG) {
      const { valid, possible, country, countryCallingCode: ccc, ext, phone } = parsed ?? {};
      L.debug('validateUsingLib()', { value, cc, ccc, country, phone, ext, possible, valid });
    }

    return fromAnyToBool(isValidNumber(parsed));
  } catch (e) {
    L.warn('validateUsingLib()', e);
    return false;
  }
});

const validatePhone = withOptions(({ value: valueFromOptions, useLib, countryCode, re }) => {
  if (isNil(valueFromOptions)) return null;
  if (valueFromOptions === '') return false;

  const value = fromAnyToSpacelessString(valueFromOptions);

  if (useLib) {
    return validateUsingLib({ value, countryCode });
  }

  return re === 'uk' ? fromAnyToBool(RE_UK_PHONE.test(value)) : fromAnyToBool(RE_ANY_PHONE.test(value));
});

// noinspection JSUnusedGlobalSymbols
export default validatePhone;
